import React, { useEffect, useState, useRef } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Carousel } from 'react-bootstrap';
import 'aos/dist/aos.css';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import { Typewriter } from 'react-simple-typewriter';


function Home() {
  const videoRef = useRef(null);
  const [reverse, setReverse] = useState(false);
  const navigate = useNavigate();

  const handleEnded = () => setReverse(r => !r);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    // عند انتهاء الفيديو
    const handleTimeUpdate = () => {
      if (reverse && video.currentTime <= 0.05) {
        setReverse(false);
        video.currentTime = 0.01;
        video.play();
      }
    };

    video.addEventListener('timeupdate', handleTimeUpdate);

    return () => {
      video.removeEventListener('timeupdate', handleTimeUpdate);
    };
  }, [reverse]);

  useEffect(() => {
    // initialize particles backgrounds for white sections
    const config = {
      fullScreen: { enable: false },
      background: { color: { value: 'transparent' } },
      fpsLimit: 60,
      particles: {
        number: { value: 45, density: { enable: true, area: 800 } },
        color: { value: ['#0c61c0'] },
        opacity: { value: 0.5 },
        size: { value: { min: 3.5, max: 7.5 } },
        move: { enable: true, speed: 1.2, outModes: { default: 'out' } },
        links: { enable: true, distance: 220, color: '#ff6600', opacity: 0.5, width: 2.5 }
      },
      interactivity: {
        detectsOn: 'window',
        events: { onHover: { enable: false }, onClick: { enable: false }, resize: true }
      },
      detectRetina: true
    };

    const loadFor = (id) => {
      if (!window.tsParticles) return;
      const el = document.getElementById(id);
      if (el) window.tsParticles.load(id, config);
    };

    const init = () => {
      ['tsp-gap', 'tsp-commitment', 'tsp-spec-personnel', 'tsp-why-choose', 'tsp-services'].forEach(loadFor);
    };

    init();
    const t = setTimeout(init, 300);
    return () => {
      clearTimeout(t);
    };
  }, []);

  return (
    <>
      {/* Hero Section with Video Background and Typewriter Text */}
      <div style={{ position: 'relative', height: '100vh', width: '100%', overflow: 'hidden', top: '-122px' }}>
        {/* فيديو الخلفية */}
        <video
          ref={videoRef}
          autoPlay
          muted
          loop
          playsInline
          onEnded={handleEnded}
          key={reverse ? 'reverse' : 'normal'}
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            zIndex: 0,
          }}
        >
          <source src={reverse ? '/assets/home-reverse.mp4' : '/assets/home.mp4'} type="video/mp4" />
          Your browser does not support the video tag.
        </video>


        {/* النص في المنتصف */}
        <div
          className="d-flex flex-column justify-content-center align-items-center text-center hero-overlay"
          style={{
            minHeight: '101vh',
            position: 'relative',
            zIndex: 2,
            color: '#fff',
            background: 'linear-gradient(180deg, rgba(0,0,0,0.55) 0%, rgba(0,0,0,0.35) 40%, rgba(0,0,0,0.55) 100%)',
            padding: '0 16px'
          }}
        >

          <h1 style={{ fontFamily: "'Heebo', sans-serif", fontWeight: 800, fontSize: '3.8rem', lineHeight: 1.1, textTransform: 'uppercase', color: '#ffffff', textShadow: '0 6px 24px rgba(0,0,0,0.35)' }}>
            <Typewriter
              words={[
                'PETROCHOICE',
                'INTEGRATED SERVICES',
                'YOUR PARTNER IN ENERGY',
                'INNOVATION & SAFETY',
                'GLOBAL REACH',
              ]}
              loop={0}
              cursor
              cursorStyle="|"
              typeSpeed={80}
              deleteSpeed={50}
              delaySpeed={1500}
            />
          </h1>
          <p className="mt-3 mb-4" style={{ fontFamily: "'Nunito', sans-serif", fontSize: '1.15rem', color: '#e9eefc', maxWidth: 880 }}>
            Truly professional and reputable multinational company.
          </p>
          <button
            type="button"
            className="btn btn-hero-primary text-white fw-bold px-5 py-3"
            style={{ background: 'linear-gradient(90deg, #0c61c0 0%, #084b9a 100%)', border: '1px solid #0c61c0', borderRadius: 10, boxShadow: '0 8px 22px rgba(12,97,192,0.35)', fontFamily: "'Nunito', sans-serif", fontSize: '1.05rem', letterSpacing: 0.3 }}
            onClick={() => navigate('/about')}
          >
            DISCOVER NOW
          </button>
          <div className="mt-3">
            <button
              type="button"
              className="btn btn-hero-ghost text-white fw-bold px-4 py-3"
              style={{ background: 'rgba(12,97,192,0.12)', border: '1px solid #0c61c0', borderRadius: 10, backdropFilter: 'blur(3px)', fontFamily: "'Nunito', sans-serif", fontSize: '1.0rem' }}
              onClick={() => navigate('/quote')}
            >
              GET A QUOTE
            </button>
          </div>

          {/* Scroll indicator */}
          <div style={{ position: 'absolute', bottom: 18, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <span style={{ fontSize: 12, color: '#dbe6ff', opacity: 0.8 }}>Scroll</span>
            <div style={{ width: 24, height: 40, borderRadius: 16, border: '2px solid #dbe6ff', opacity: 0.8, position: 'relative', marginTop: 6 }}>
              <span style={{ position: 'absolute', top: 6, left: '50%', transform: 'translateX(-50%)', width: 4, height: 8, borderRadius: 2, background: '#dbe6ff', animation: 'scrollDot 1.6s ease-in-out infinite' }}></span>
            </div>
          </div>
        </div>
      </div>

      <>
        <style>
          {`
          .btn-hero:hover { filter: brightness(1.06); transform: translateY(-1px); transition: all 0.2s ease; }
          .btn-hero:active { transform: translateY(0); }
          @keyframes scrollDot { 0% { opacity: 0; transform: translate(-50%,0); } 20% { opacity: 1; } 100% { opacity: 0; transform: translate(-50%,14px); } }
          .particles-section-bg {
            position: absolute;
            inset: 0;
            z-index: 0;
            pointer-events: none;
          }
          .card-hover {
            position: relative;
            background-color: white;
            transition: background-color 0.8s ease;
            overflow: hidden;
          }

          .card-hover .icon-circle {
            width: 50px;
            height: 50px;
            background-color: #0c61c0;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            color: white;
            transition: all 0.8s ease;
            margin-bottom: 1rem;
          }

          .card-hover:hover {
            background-color: #0c61c0 !important;
          }

          .card-hover:hover .icon-circle {
            transform: scale(10);
            opacity: 0;
          }

          .card-hover:hover .icon-circle i {
            opacity: 0;
          }

          .card-hover:hover .title-text,
          .card-hover:hover .subtitle-text,
          .card-hover:hover .desc-text {
            color: white !important;
          }

          .card-hover .title-text,
          .card-hover .subtitle-text,
          .card-hover .desc-text {
            transition: color 1s ease;
          }
        `}
        </style>

        {/* Uniface Gap Section between Hero and Our Commitment */}
        <div className="position-relative particles-section" style={{ minHeight: '140px', width: '100%' }}>
          <div id="tsp-gap" className="particles-section-bg"></div>
        </div>

        {/* Our Commitment Section */}
        <div
          className="w-100 py-5 position-relative particles-section"
          style={{
            backgroundImage: 'linear-gradient(180deg, rgba(255,255,255,0.96) 0%, rgba(255,255,255,0.92) 40%, rgba(255,255,255,0.96) 100%), url("/assets/bg-what-we-can.jpg")',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            minHeight: '100vh',
            width: '100%',
            position: 'relative',
            overflow: 'hidden'
          }}
        >
          <div id="tsp-commitment" className="particles-section-bg"></div>
          <div className="container">
            <div className="row g-5 align-items-start">

              <div className="col-lg-5 wow fadeInUp" data-wow-delay="0.1s">
                <h1 className="mb-3 fw-bold" style={{ color: '#1a2a44' }}>Our Commitment</h1>
                <p style={{ color: '#0c61c0', fontWeight: '500' }}>
                  "What you can expect when dealing with petrochoice"
                </p>

                <div className="rounded overflow-hidden shadow-sm mt-4" style={{ border: '1px solid rgba(0,0,0,0.06)' }}>
                  <Carousel
                    fade
                    controls={true}
                    indicators={true}
                    interval={4000}
                    pause="hover"
                    className="carousel-dark"
                  >
                    <Carousel.Item>
                      <img
                        src="/assets/19224.jpg"
                        alt="Slide 1"
                        className="d-block w-100"
                        style={{
                          borderRadius: '14px',
                          objectFit: 'cover',
                          height: '350px',
                          transition: 'transform 1s ease-in-out',
                        }}
                      />
                      <Carousel.Caption>
                        <h5 style={{ color: '#fff', textShadow: '1px 1px 4px rgba(0,0,0,0.6)' }}>
                          Excellence in Service
                        </h5>
                      </Carousel.Caption>
                    </Carousel.Item>

                    <Carousel.Item>
                      <img
                        src="/assets/2450.jpg"
                        alt="Slide 2"
                        className="d-block w-100"
                        style={{
                          borderRadius: '14px',
                          objectFit: 'cover',
                          height: '350px',
                          transition: 'transform 1s ease-in-out',
                        }}
                      />
                      <Carousel.Caption>
                        <h5 style={{ color: '#fff', textShadow: '1px 1px 4px rgba(0,0,0,0.6)' }}>
                          Committed to Safety
                        </h5>
                      </Carousel.Caption>
                    </Carousel.Item>
                  </Carousel>
                </div>
              </div>


              {/* Cards Section */}
              <div className="col-lg-7">
                <div className="row gy-4 gx-4">
                  {[
                    {
                      icon: 'fa-handshake',
                      title: 'Client Satisfaction',
                      subtitle: 'We value our clients, and their satisfaction',
                      text: 'Our clients are of utmost importance, and we aim to exceed their expectations. We foster strong partnerships, maintain open communication, and provide personalized service.',
                    },
                    {
                      icon: 'fa-chart-line',
                      title: 'Performance Excellence',
                      subtitle: 'We are dedicated to delivering best-in-class performance',
                      text: 'We deliver top-tier performance through cutting-edge technologies and innovative solutions. Our aim is to enhance efficiency, reduce costs, and optimize outcomes.',
                    },
                    {
                      icon: 'fa-thumbs-up',
                      title: 'Safety Priority',
                      subtitle: 'We prioritize the safety of personnel',
                      text: 'Safety is our foremost concern, encompassing personnel, assets, and the environment. We implement robust protocols and proactive risk management.',
                    },
                    {
                      icon: 'fa-chart-pie',
                      title: 'Budget Control',
                      subtitle: 'We understand the significance of budget control',
                      text: 'We emphasize strict budget control through meticulous planning, cost oversight, and transparent communication to ensure project adherence.',
                    }
                  ].map((item, i) => (
                    <div className="col-md-6 wow fadeInUp" data-wow-delay={`${0.2 + i * 0.1}s`} key={i}>
                      <div
                        className="bg-white p-4 shadow-sm rounded h-100 transition position-relative card-hover"
                        style={{ transition: 'all 0.4s ease', border: '1px solid rgba(0,0,0,0.06)' }}
                      >
                        <div className="icon-circle">
                          <i className={`fas ${item.icon}`} style={{ fontSize: '20px' }}></i>
                        </div>
                        <h6 className="fw-bold title-text" style={{ color: '#1a2a44' }}>
                          {item.title.toUpperCase()}
                        </h6>
                        <p className="fst-italic subtitle-text" style={{ fontSize: '14px' }}>
                          {item.subtitle}
                        </p>
                        <p className="desc-text" style={{ fontSize: '14px', color: '#555' }}>
                          {item.text}
                        </p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

            </div>
          </div>
        </div>
      </>

      <style>
        {`
          .about-section {
            background-color: #164c96;
            color: #fff;
            padding: 100px 0;
            font-family: 'Nunito', sans-serif;
            border-radius: 0 !important;
            margin: 0 !important;
            overflow: visible !important;
          }

          .about-titlee {
            font-size: 2.8rem;
            font-weight: 700;
            margin-bottom: 10px;
            color: #fff;
          }

          .about-line {
            width: 60px;
            height: 3px;
            background-color: #f57c00;
            margin-bottom: 20px;
          }

          .about-desc {
            font-size: 1.25rem;
            color: #dce4f3;
            line-height: 1.7;
            margin-bottom: 20px;
          }

          .about-highlight {
            font-weight: 700;
            font-size: 1.1rem;
          }

          .progress-label {
            color: #f57c00;
            font-weight: 600;
            font-size: 14px;
            display: flex;
            justify-content: space-between;
          }

          .progress-bar {
            background-color: #f57c00;
          }

          .read-more {
            color: #fff;
            font-weight: 600;
            margin-top: 15px;
            display: inline-block;
            text-decoration: none;
          }

          .read-more i {
            margin-left: 6px;
            transition: transform 0.3s ease;
          }

          .read-more:hover i {
            transform: translateX(5px);
          }

          .image-stack {
            position: relative;
            height: 460px;
          }

          .image-box {
            position: absolute;
            width: 85%;
            height: 50%;
            background-color: white;
            margin-bottom: -10%;
            border: 2px solid #f57c00;
            border-radius: 14px;
            box-shadow: 0 8px 18px rgba(0, 0, 0, 0.2);
            overflow: hidden;
            transition: transform 0.4s ease;
          }

          .image-box:hover {
            transform: scale(1.03);
          }

          .image-box img {
            width: 100%;
            height: auto;
            border-radius: 12px;
            transition: transform 0.4s ease;
          }

          .image-box.top-left {
            top: 0;
            left: 0;
            z-index: 2;
          }

          .image-box.bottom-right {
            bottom: 0;
            right: 0;
            z-index: 1;
          }

          @media (max-width: 768px) {
            .image-stack {
              height: auto;
              display: flex;
              flex-direction: column;
              gap: 20px;
            }

            .image-box {
              position: relative;
              width: 100%;
            }
          }

          @media (max-width: 768px) {
            body {
              overflow-x: hidden !important;
            }
            [data-aos="fade-left"] {
              opacity: 1 !important;
              transform: none !important;
              transition: none !important;
            }
            .text-center.text-lg-start.p-4.rounded {
              padding: 1rem !important;
              width: 100% !important;
            }
          }
        `}
      </style>

      {/* About Us Section */}
      <div
        className="position-relative py-5"
        style={{
          background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 50%, #334155 100%)',
          minHeight: '100vh',
          overflow: 'hidden'
        }}
      >
        {/* Background Pattern */}
        <div
          className="position-absolute top-0 start-0 w-100 h-100"
          style={{
            backgroundImage: `url("data:image/svg+xml,%3Csvg width='80' height='80' viewBox='0 0 80 80' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.05'%3E%3Cpath d='M0 0h40v40H0V0zm40 40h40v40H40V40zm0-40h2l-2 2V0zm0 4l4-4h2l-6 6V4zm0 4l8-8h2L40 10V8zm0 4L52 0h2L40 14v-2zm0 4L56 0h2L40 18v-2zm0 4L60 0h2L40 22v-2zm0 4L64 0h2L40 26v-2zm0 4L68 0h2L40 30v-2zm0 4L72 0h2L40 34v-2zm0 4L76 0h2L40 38v-2zm0 4L80 0v2L42 40h-2zm4 0L80 4v2L46 40h-2zm4 0L80 8v2L50 40h-2zm4 0l28-28v2L54 40h-2zm4 0l24-24v2L58 40h-2zm4 0l20-20v2L62 40h-2zm4 0l16-16v2L66 40h-2zm4 0l12-12v2L70 40h-2zm4 0l8-8v2l-6 6h-2zm4 0l4-4v2l-2 2h-2z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
            opacity: 0.3
          }}
        ></div>

        <div className="container position-relative" style={{ zIndex: 2 }}>
          <div className="row g-5 align-items-center">
            {/* Left Images */}
            <div className="col-lg-6" data-aos="fade-right">
              <div className="position-relative">
                {/* Main Image */}
                <div
                  className="position-relative rounded-4 overflow-hidden mb-4"
                  style={{
                    boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.4)',
                    border: '3px solid rgba(255, 255, 255, 0.2)'
                  }}
                >
                  <img
                    src="/assets/110070.jpg"
                    alt="Professional Worker"
                    className="w-100"
                    style={{ height: '400px', objectFit: 'cover' }}
                  />
                  <div
                    className="position-absolute top-0 start-0 w-100 h-100"
                    style={{
                      background: 'linear-gradient(45deg, rgba(59, 130, 246, 0.3) 0%, rgba(30, 64, 175, 0.3) 100%)'
                    }}
                  ></div>
                </div>

                {/* Floating Stats Card */}
                <div
                  className="position-absolute top-0 end-0 bg-white rounded-4 p-4 shadow-lg"
                  style={{
                    transform: 'translate(20px, -20px)',
                    border: '1px solid rgba(255, 255, 255, 0.2)',
                    backdropFilter: 'blur(10px)',
                    minWidth: '200px'
                  }}
                >
                  <div className="text-center">
                    <div className="d-flex align-items-center justify-content-center mb-2">
                      <i className="fas fa-award text-warning me-2" style={{ fontSize: '1.5rem' }}></i>
                      <span className="fw-bold text-primary" style={{ fontSize: '1.2rem' }}>5+</span>
                    </div>
                    <p className="mb-0 text-muted" style={{ fontSize: '0.9rem' }}>Years of Excellence</p>
                  </div>
                </div>


                {/* Secondary Image */}
                <div
                  className="position-relative rounded-4 overflow-hidden"
                  style={{
                    boxShadow: '0 20px 40px -12px rgba(0, 0, 0, 0.3)',
                    border: '2px solid rgba(255, 255, 255, 0.15)',
                    transform: 'translateX(-30px)'
                  }}
                >
                  <img
                    src="/assets/2151615054.jpg"
                    alt="Shipping Operations"
                    className="w-100"
                    style={{ height: '400px', objectFit: 'cover' }}
                  />
                  <div
                    className="position-absolute bottom-0 start-0 w-100 p-3"
                    style={{
                      background: 'linear-gradient(transparent, rgba(0,0,0,0.7))',
                      color: 'white'
                    }}
                  >
                    <h6 className="mb-1 fw-bold">Global Operations</h6>
                    <p className="mb-0 opacity-75" style={{ fontSize: '0.9rem' }}>Worldwide Service Network</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Right Content */}
            <div className="col-lg-6" data-aos="fade-left" data-aos-delay="100">
              <div className="text-white">
                {/* Badge */}
                <div className="mb-3">
                  <span
                    className="badge px-3 py-2"
                    style={{
                      backgroundColor: 'rgba(255, 255, 255, 0.15)',
                      color: '#f8fafc',
                      fontSize: '0.85rem',
                      fontWeight: '500',
                      borderRadius: '20px',
                      border: '1px solid rgba(255, 255, 255, 0.2)'
                    }}
                  >
                    ABOUT PETROCHOICE
                  </span>
                </div>

                {/* Title */}
                <h2
                  className="fw-bold mb-4"
                  style={{
                    fontSize: '3.2rem',
                    fontFamily: "'Poppins', sans-serif",
                    letterSpacing: '-0.5px',
                    lineHeight: '1.1',
                    color: '#f8fafc'
                  }}
                >
                  Leading Global Energy Solutions
                </h2>

                {/* Description */}
                <p
                  className="mb-4"
                  style={{
                    fontSize: '1.2rem',
                    lineHeight: '1.8',
                    color: '#cbd5e1',
                    fontFamily: "'Inter', sans-serif"
                  }}
                >
                  Petrochoice is an internationally renowned corporation that specializes in delivering outstanding services to the oil and gas sector on a global scale.
                </p>

                {/* Highlight */}
                <div
                  className="bg-white bg-opacity-8 rounded-4 p-4 mb-4"
                  style={{
                    border: '1px solid rgba(255, 255, 255, 0.15)',
                    backdropFilter: 'blur(10px)'
                  }}
                >
                  <p
                    className="mb-0 fw-semibold"
                    style={{
                      fontSize: '1.1rem',
                      color: '#000000',
                      fontFamily: "'Inter', sans-serif"
                    }}
                  >
                    "Leveraging our substantial knowledge and robust infrastructure, our unwavering commitment is to consistently achieve excellence across all facets of our operations."
                  </p>
                </div>

                {/* CTA Button */}
                <Link
                  to="/about"
                  className="btn btn-lg fw-bold px-4 py-3 mb-4"
                  style={{
                    borderRadius: '12px',
                    fontSize: '1.1rem',
                    background: 'linear-gradient(90deg, #0c61c0, #084b9a)',
                    border: '1px solid #0c61c0',
                    color: '#f8fafc',
                    boxShadow: '0 10px 25px rgba(12, 97, 192, 0.35)',
                    transition: 'all 0.3s ease',
                    textDecoration: 'none',
                    display: 'inline-block'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'translateY(-2px)';
                    e.currentTarget.style.boxShadow = '0 15px 35px rgba(12, 97, 192, 0.45)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.boxShadow = '0 10px 25px rgba(12, 97, 192, 0.35)';
                  }}
                >
                  Discover Our Story <i className="fas fa-arrow-right ms-2"></i>
                </Link>

                {/* Progress Bars */}
                <div className="row g-4">
                  <div className="col-md-6">
                    <div className="mb-3">
                      <div className="d-flex justify-content-between align-items-center mb-2">
                        <span className="text-white fw-semibold" style={{ fontSize: '0.9rem' }}>ACCURACY</span>
                        <span className="fw-bold" style={{ color: '#cbd5e1' }}>95%</span>
                      </div>
                      <div
                        className="progress"
                        style={{
                          height: '8px',
                          backgroundColor: 'rgba(255, 255, 255, 0.15)',
                          borderRadius: '10px',
                          overflow: 'hidden'
                        }}
                      >
                        <div
                          className="progress-bar"
                          style={{
                            width: '95%',
                            background: 'linear-gradient(90deg, #64748b 0%, #475569 100%)',
                            borderRadius: '10px',
                            transition: 'width 2s ease-in-out'
                          }}
                        ></div>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="mb-3">
                      <div className="d-flex justify-content-between align-items-center mb-2">
                        <span className="text-white fw-semibold" style={{ fontSize: '0.9rem' }}>EXPERTISE</span>
                        <span className="fw-bold" style={{ color: '#cbd5e1' }}>98%</span>
                      </div>
                      <div
                        className="progress"
                        style={{
                          height: '8px',
                          backgroundColor: 'rgba(255, 255, 255, 0.15)',
                          borderRadius: '10px',
                          overflow: 'hidden'
                        }}
                      >
                        <div
                          className="progress-bar"
                          style={{
                            width: '98%',
                            background: 'linear-gradient(90deg, #64748b 0%, #475569 100%)',
                            borderRadius: '10px',
                            transition: 'width 2s ease-in-out'
                          }}
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>



      {/* Integrated Drilling Management Section */}
      <div
        className="position-relative d-flex align-items-center"
        style={{
          backgroundImage: `linear-gradient(135deg, rgba(15, 23, 42, 0.9) 0%, rgba(30, 41, 59, 0.8) 100%), url('/assets/field-with-oil.jpg')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundAttachment: 'fixed',
          minHeight: '100vh',
          overflow: 'hidden'
        }}
      >
        {/* Animated Background Elements */}
        <div
          className="position-absolute top-0 start-0 w-100 h-100"
          style={{
            background: 'radial-gradient(circle at 20% 80%, rgba(59, 130, 246, 0.1) 0%, transparent 50%), radial-gradient(circle at 80% 20%, rgba(251, 191, 36, 0.1) 0%, transparent 50%)',
            animation: 'pulse 4s ease-in-out infinite alternate'
          }}
        ></div>

        <div className="container py-5 position-relative" style={{ zIndex: 2 }}>
          {/* Section Header */}
          <div className="row justify-content-center mb-5">
            <div className="col-lg-10 text-center">
              <div className="mb-3">
                <span
                  className="badge px-4 py-2"
                  style={{
                    backgroundColor: 'rgba(255, 255, 255, 0.15)',
                    color: '#f8fafc',
                    fontSize: '0.9rem',
                    fontWeight: '600',
                    borderRadius: '25px',
                    border: '1px solid rgba(255, 255, 255, 0.2)'
                  }}
                >
                  INTEGRATED SOLUTIONS
                </span>
              </div>
              <h1
                className="text-white fw-bold mb-3"
                style={{
                  fontSize: '3.5rem',
                  fontFamily: "'Poppins', sans-serif",
                  letterSpacing: '-0.5px',
                  textShadow: '0 4px 20px rgba(0,0,0,0.5)',
                  color: '#f8fafc'
                }}
              >
                Integrated Drilling Management
              </h1>
              <p
                className="lead"
                style={{
                  fontSize: '1.3rem',
                  fontFamily: "'Inter', sans-serif",
                  maxWidth: '800px',
                  margin: '0 auto',
                  color: '#cbd5e1'
                }}
              >
                Advanced management services designed to optimize drilling operations and enhance efficiency
              </p>
            </div>
          </div>

          <div className="row g-5 justify-content-center">
            {/* Light-WIMS Section */}
            <div className="col-lg-10" data-aos="fade-up" data-aos-delay="100">
              <div
                className="bg-white bg-opacity-95 rounded-4 overflow-hidden shadow-lg"
                style={{
                  backdropFilter: 'blur(10px)',
                  border: '1px solid rgba(255, 255, 255, 0.2)'
                }}
              >
                <div className="row g-0">
                  {/* Image Section */}
                  <div className="col-md-5 position-relative">
                    <div className="position-relative h-100">
                      <img
                        src="/assets/portrait-engineer.jpg"
                        alt="Light-WIMS System"
                        className="w-100 h-100"
                        style={{ objectFit: 'cover', minHeight: '300px' }}
                      />
                      <div
                        className="position-absolute top-0 start-0 w-100 h-100"
                        style={{
                          background: 'linear-gradient(45deg, rgba(59, 130, 246, 0.3) 0%, rgba(30, 64, 175, 0.3) 100%)'
                        }}
                      ></div>

                      {/* Floating Icon */}
                      <div
                        className="position-absolute top-3 end-3 bg-white rounded-circle d-flex align-items-center justify-content-center"
                        style={{ width: '60px', height: '60px', boxShadow: '0 8px 25px rgba(0,0,0,0.2)' }}
                      >
                        <i className="fas fa-cogs text-primary" style={{ fontSize: '1.5rem' }}></i>
                      </div>
                    </div>
                  </div>

                  {/* Content Section */}
                  <div className="col-md-7 p-5 d-flex flex-column justify-content-between">
                    <div>
                      <div className="mb-3">
                        <span
                          className="badge px-3 py-2 mb-2"
                          style={{
                            backgroundColor: '#3b82f6',
                            color: 'white',
                            fontSize: '0.8rem',
                            fontWeight: '500',
                            borderRadius: '15px'
                          }}
                        >
                          LIGHT-WIMS
                        </span>
                      </div>
                      <h3
                        className="fw-bold mb-3"
                        style={{
                          color: '#1e293b',
                          fontSize: '2rem',
                          fontFamily: "'Poppins', sans-serif"
                        }}
                      >
                        Light Well Integrated Management System
                      </h3>
                      <p
                        className="mb-4"
                        style={{
                          fontSize: '1.1rem',
                          lineHeight: '1.7',
                          color: '#64748b',
                          fontFamily: "'Inter', sans-serif"
                        }}
                      >
                        Our Light Well Integrated Management System (Light-WIMS) represents the pinnacle of drilling optimization technology, providing comprehensive oversight and control of all drilling operations.
                      </p>

                      {/* Features List */}
                      <div className="row g-3 mb-4">
                        {[
                          { icon: 'fa-chart-line', text: 'Real-time Monitoring' },
                          { icon: 'fa-shield-alt', text: 'Safety Protocols' },
                          { icon: 'fa-cogs', text: 'Automated Controls' }
                        ].map((feature, index) => (
                          <div className="col-md-4" key={index}>
                            <div className="d-flex align-items-center">
                              <div
                                className="d-flex align-items-center justify-content-center me-3"
                                style={{
                                  width: '40px',
                                  height: '40px',
                                  borderRadius: '10px',
                                  backgroundColor: '#f1f5f9'
                                }}
                              >
                                <i className={`fas ${feature.icon} text-primary`} style={{ fontSize: '1rem' }}></i>
                              </div>
                              <span style={{ fontSize: '0.9rem', color: '#64748b', fontWeight: '500' }}>
                                {feature.text}
                              </span>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>

                    <button
                      type="button"
                      className="btn btn-primary btn-lg fw-bold px-4 py-2 align-self-start"
                      style={{
                        borderRadius: '12px',
                        fontSize: '1rem',
                        boxShadow: '0 8px 20px rgba(59, 130, 246, 0.3)',
                        transition: 'all 0.3s ease'
                      }}
                      onClick={() => navigate('/services/integrated-drilling/light-wims')}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = 'translateY(-2px)';
                        e.currentTarget.style.boxShadow = '0 12px 25px rgba(59, 130, 246, 0.4)';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = 'translateY(0)';
                        e.currentTarget.style.boxShadow = '0 8px 20px rgba(59, 130, 246, 0.3)';
                      }}
                    >
                      Learn More <i className="fas fa-arrow-right ms-2"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>

            {/* FD-WIMS Section */}
            <div className="col-lg-10" data-aos="fade-up" data-aos-delay="300">
              <div
                className="bg-dark bg-opacity-90 rounded-4 overflow-hidden shadow-lg"
                style={{
                  backdropFilter: 'blur(10px)',
                  border: '1px solid rgba(255, 255, 255, 0.1)'
                }}
              >
                <div className="row g-0">
                  {/* Content Section */}
                  <div className="col-md-7 p-5 d-flex flex-column justify-content-between text-white">
                    <div>
                      <div className="mb-3">
                        <span
                          className="badge px-3 py-2 mb-2"
                          style={{
                            backgroundColor: '#ff6600',
                            color: '#ffffff',
                            fontSize: '0.8rem',
                            fontWeight: '500',
                            borderRadius: '15px'
                          }}
                        >
                          FD-WIMS <span className="badge bg-warning ms-1">Coming Soon</span>
                        </span>
                      </div>
                      <h3
                        className="fw-bold mb-3"
                        style={{
                          fontSize: '2rem',
                          fontFamily: "'Poppins', sans-serif"
                        }}
                      >
                        Full Drilling Management System
                      </h3>
                      <p
                        className="mb-4"
                        style={{
                          fontSize: '1.1rem',
                          lineHeight: '1.7',
                          color: '#e2e8f0',
                          fontFamily: "'Inter', sans-serif"
                        }}
                      >
                        Petrochoice is forging strategic partnerships with leading industry service providers, uniting Rig contractors, Cementing specialists, and technology innovators to deliver comprehensive drilling solutions.
                      </p>

                      {/* Features List */}
                      <div className="row g-3 mb-4">
                        {[
                          { icon: 'fa-handshake', text: 'Strategic Partnerships' },
                          { icon: 'fa-users', text: 'Expert Teams' },
                          { icon: 'fa-rocket', text: 'Innovation Focus' }
                        ].map((feature, index) => (
                          <div className="col-md-4" key={index}>
                            <div className="d-flex align-items-center">
                              <div
                                className="d-flex align-items-center justify-content-center me-3"
                                style={{
                                  width: '40px',
                                  height: '40px',
                                  borderRadius: '10px',
                                  backgroundColor: 'rgba(251, 191, 36, 0.2)'
                                }}
                              >
                                <i className={`fas ${feature.icon} text-warning`} style={{ fontSize: '1rem' }}></i>
                              </div>
                              <span style={{ fontSize: '0.9rem', color: '#e2e8f0', fontWeight: '500' }}>
                                {feature.text}
                              </span>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>

                    <button
                      type="button"
                      className="btn btn-lg fw-bold px-4 py-2 align-self-start"
                      style={{
                        borderRadius: '12px',
                        fontSize: '1rem',
                        background: 'linear-gradient(90deg, #ff6600, #e55a00)',
                        border: '1px solid #ff6600',
                        color: '#fff',
                        boxShadow: '0 8px 20px rgba(255, 102, 0, 0.35)',
                        transition: 'all 0.3s ease'
                      }}
                      onClick={() => navigate('/services/integrated-drilling/fd-wms')}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = 'translateY(-2px)';
                        e.currentTarget.style.boxShadow = '0 12px 25px rgba(255, 102, 0, 0.45)';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = 'translateY(0)';
                        e.currentTarget.style.boxShadow = '0 8px 20px rgba(255, 102, 0, 0.35)';
                      }}
                    >
                      Explore System <i className="fas fa-arrow-right ms-2"></i>
                    </button>
                  </div>

                  {/* Image Section */}
                  <div className="col-md-5 position-relative">
                    <div className="position-relative h-100">
                      <img
                        src="/assets/industrial-factory.jpg"
                        alt="FD-WIMS System"
                        className="w-100 h-100"
                        style={{ objectFit: 'cover', minHeight: '300px' }}
                      />
                      <div
                        className="position-absolute top-0 start-0 w-100 h-100"
                        style={{
                          background: 'linear-gradient(45deg, rgba(251, 191, 36, 0.3) 0%, rgba(245, 158, 11, 0.3) 100%)'
                        }}
                      ></div>

                      {/* Floating Icon */}
                      <div
                        className="position-absolute top-3 start-3 bg-white rounded-circle d-flex align-items-center justify-content-center"
                        style={{ width: '60px', height: '60px', boxShadow: '0 8px 25px rgba(0,0,0,0.2)' }}
                      >
                        <i className="fas fa-industry text-warning" style={{ fontSize: '1.5rem' }}></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <section className="py-5 bg-white position-relative particles-section" data-aos="zoom-in">
        <div id="tsp-spec-personnel" className="particles-section-bg"></div>
        <div className="container" style={{ position: 'relative', zIndex: 1 }}>
          {/* Section Title - Left Aligned */}
          <div className="mb-5" data-aos="fade-right">
            <h2
              className="fw-bold"
              style={{
                fontSize: '2.5rem',
                color: '#1e293b',
                fontFamily: 'Poppins, sans-serif',
                letterSpacing: '-0.5px',
              }}
            >
              Specialized Drilling Personnel
            </h2>

            <div
              style={{
                width: '80px',
                height: '3px',
                backgroundColor: '#475569',
                marginTop: '10px',
              }}
            ></div>
          </div>

          {/* Personnel Cards */}
          <div className="row g-4 justify-content-center">
            {[
              {
                title: "Drilling Engineers",
                delay: 0,
                desc: "Our drilling engineers are highly skilled professionals with extensive experience in planning and executing drilling operations. They design safe and efficient well programs, monitor drilling performance, and implement best practices to optimize safety, reduce costs, and enhance operational efficiency.",
                icon: "fas fa-user-tie"
              },
              {
                title: "Drilling SuperIntendents",
                delay: 100,
                desc: "Our drilling superintendents are experienced leaders responsible for overseeing all drilling operations. They ensure that projects are executed safely, efficiently, and in compliance with company standards. By coordinating between on-site teams and engineering departments, they optimize performance, manage resources, and drive operational excellence across all drilling activities.",
                icon: "fas fa-user-tie"
              },
              {
                title: "Drilling/Workover Supervisors",
                delay: 200,
                desc: "Drilling and workover supervisors manage and coordinate all rig-site operations, ensuring safety, efficiency, and adherence to project plans. Their leadership and technical expertise enable seamless execution of drilling and workover activities while minimizing risks and optimizing performance.",
                icon: "fas fa-user-tie"
              },
              {
                title: "Drilling Fluid Specialists",
                delay: 300,
                desc: "Drilling fluid specialists manage the formulation, testing, and maintenance of drilling fluids to ensure safe and efficient drilling operations. They ensure proper fluid properties for hole stability, hole cleaning, and environmental protection, optimizing drilling efficiency and minimizing risks.",
                icon: "fas fa-flask"
              },
              {
                title: "Rig Crew Members",
                delay: 400,
                desc: "Our rig crew members, including drillers and toolpushers, are essential for operating drilling equipment. They ensure smooth operations, maintain rig services, and support emergency procedures, contributing to the overall success of drilling projects.",
                icon: "fas fa-users"
              },
              {
                title: "Cementing Specialists",
                delay: 500,
                desc: "Cementing specialists ensure wellbore integrity through expert cement placement optimization. They design cement slurries and manage long-term well management, preventing formation fluid migration and ensuring zonal isolation.",
                icon: "fas fa-layer-group"
              },
              {
                title: "Well Site Geologists",
                delay: 600,
                desc: "Well site geologists provide critical subsurface formation analysis and geological complexity assessment. They offer insights for wellsites positioning strategy and hydrocarbon recovery, enhancing reservoir engineering and long-term management of drilling projects.",
                icon: "fas fa-mountain"
              },
              {
                title: "Drilling Bit Specialists",
                delay: 700,
                desc: "Drilling bit specialists manage the selection, maintenance, and performance of drilling bits to optimize drilling efficiency and hole stability. They ensure proper bit selection for different formation types, maintain bit performance, and implement best practices for bit selection and replacement, enhancing drilling productivity and minimizing costs.",
                icon: "fas fa-cog"
              },
              {
                title: "Completion Specialists",
                delay: 800,
                desc: "Completion specialists specialize in well-completion design and operations. They have comprehensive knowledge of completion techniques, downhole equipment, and well-stimulation methods. Their expertise ensures the successful completion of wells, maximizing production potential and optimizing reservoir performance.",
                icon: "fas fa-tools"
              },
              {
                title: "Well Control Specialists",
                delay: 900,
                desc: "Well control specialists are responsible for maintaining wellbore integrity and managing well control incidents during drilling operations. They possess in-depth knowledge of well control principles, equipment, and emergency procedures. Their expertise ensures safe and effective well control, minimizing risks and ensuring operational safety.",
                icon: "fas fa-shield-alt"
              }
            ].map((item, i) => (
              <div key={i} className="col-md-6 col-lg-4" data-aos="fade-up" data-aos-delay={item.delay}>
                <div className="card h-100 border-0 shadow-sm">
                  <div className="card-body p-4">
                    <div className="d-flex align-items-center mb-3">
                      <div className="bg-primary rounded-circle d-flex align-items-center justify-content-center me-3" style={{ width: '50px', height: '50px' }}>
                        <i className={`${item.icon} text-white`}></i>
                      </div>
                      <h6 className="fw-bold mb-0" style={{ fontSize: '1.1rem', fontFamily: 'Poppins, sans-serif', color: '#1e293b' }}>
                        {item.title}
                      </h6>
                    </div>
                    <p style={{ fontSize: '1rem', fontFamily: 'Poppins, sans-serif', lineHeight: '1.6', color: '#64748b', textAlign: 'justify' }}>
                      {item.desc}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Why Choose Us - animated features */}
      <section className="py-5 bg-white position-relative particles-section" data-aos="fade-up">
        <div id="tsp-why-choose" className="particles-section-bg"></div>
        <div className="container" style={{ position: 'relative', zIndex: 1 }}>
          <div className="text-center mb-4">
            <h3 className="fw-bold" style={{ color: '#1e293b' }}>Why Choose Petrochoice</h3>
            <p style={{ color: '#64748b' }}>Trusted expertise, safety-first culture, and measurable performance.</p>
          </div>
          <div className="row g-4">
            {[
              { icon: 'bi-shield-check', title: 'Safety First', text: 'We embed safety into every task and decision.' },
              { icon: 'bi-graph-up-arrow', title: 'Proven Results', text: 'Optimized efficiency with cost-conscious delivery.' },
              { icon: 'bi-cpu', title: 'Technology-Driven', text: 'Modern tools and data-backed workflows.' },
              { icon: 'bi-people', title: 'Expert Team', text: 'Specialists across drilling and operations.' }
            ].map((f, idx) => (
              <div className="col-md-6 col-lg-3" key={idx} data-aos="zoom-in" data-aos-delay={idx * 100}>
                <div className="h-100 p-4 bg-white rounded shadow-sm" style={{ border: '1px solid rgba(0,0,0,0.06)', transition: 'transform .2s ease' }}>
                  <div className="mb-3"><i className={`bi ${f.icon}`} style={{ fontSize: 28, color: '#475569' }}></i></div>
                  <h6 className="fw-bold mb-2" style={{ color: '#1e293b' }}>{f.title}</h6>
                  <p className="mb-0" style={{ fontSize: '0.95rem', color: '#64748b' }}>{f.text}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>


      {/* Manpower styles */}
      <style>
        {`
          .manpower-section {
            position: relative;
             background: linear-gradient(135deg, #0f172a 0%, #1e293b 100%);
            overflow: hidden;
          }
          .manpower-overlay {
            position: absolute;
            inset: 0;
            background: radial-gradient(1200px 600px at -10% -10%, rgba(255,255,255,0.06) 0%, transparent 60%),
                        radial-gradient(1200px 600px at 110% 110%, rgba(255,255,255,0.06) 0%, transparent 60%);
            pointer-events: none;
          }
          .manpower-title {
             color: #f8fafc;
            font-family: 'Poppins', sans-serif;
            font-size: 2.7rem;
            font-weight: 800;
            letter-spacing: -0.5px;
          }
          .manpower-badge {
            display: inline-block;
            background: rgba(255,255,255,0.12);
            color: #fff;
            padding: 6px 14px;
            border-radius: 999px;
            font-weight: 700;
            font-size: 0.8rem;
            letter-spacing: 1px;
            margin-bottom: 12px;
            border: 1px solid rgba(255,255,255,0.2);
          }
          .manpower-desc {
            font-family: 'Poppins', sans-serif;
            font-size: 1.05rem;
            line-height: 1.9;
            color: #e9eefc;
          }
          .manpower-list {
            margin-top: 18px;
          }
          .manpower-list li {
            display: flex;
            align-items: flex-start;
            gap: 10px;
            margin-bottom: 10px;
            font-family: 'Poppins', sans-serif;
            font-size: 1rem;
          }
          .manpower-list i {
             color: #cbd5e1;
            font-size: 1.1rem;
            margin-top: 2px;
          }
          .manpower-image {
            position: relative;
            border-radius: 16px;
            overflow: hidden;
            box-shadow: 0 12px 30px rgba(0,0,0,0.25);
            border: 1px solid rgba(255,255,255,0.15);
          }
          .manpower-image img {
            display: block;
            width: 100%;
            height: 100%;
            object-fit: cover;
            transition: transform 0.6s ease;
          }
          .manpower-image:hover img {
            transform: scale(1.04);
          }
          .manpower-card {
            background: rgba(255,255,255,0.06);
            color: #fff;
            border: 1px solid rgba(255,255,255,0.2);
            border-radius: 16px;
            box-shadow: 0 10px 30px rgba(0,0,0,0.25);
            backdrop-filter: blur(6px);
            -webkit-backdrop-filter: blur(6px);
          }
          @media (max-width: 991px) {
            .manpower-title { font-size: 2.1rem; }
          }
        `}
      </style>

      {/* COMMENTED OUT - MANPOWER SECTION
      <section className="manpower-section text-white">
        <div className="manpower-overlay"></div>
        <div className="container py-5">
          <div className="row align-items-center g-4">
            {/* Left Column - Text */}
            {/* <div className="col-lg-6" data-aos="fade-right">
              <span className="manpower-badge">OUR EXPERT TEAM</span>
              <h2 className="manpower-title mb-3">Manpower Supply</h2>
              <p className="manpower-desc">
                At Petrochoice, our team of specialized drilling personnel and performance specialists,
                including rig crew members, cover all essential areas of drilling operations.
              </p>
              <ul className="manpower-list list-unstyled">
                {[
                  'Well Control Specialists',
                  'Geology Specialists',
                  'Petroleum Engineering Specialists',
                  'Material Engineering Specialists',
                  'Completion Specialists',
                  'Wellhead Specialists',
                ].map((item, index) => (
                  <li key={index}>
                    <i className="fas fa-check-circle" aria-hidden="true"></i>
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </div>

            {/* Center Image */}
            {/* <div className="col-lg-3 my-4 my-lg-0" data-aos="zoom-in">
              <div className="manpower-image" style={{ minHeight: '280px' }}>
                <img src="/assets/workers.png" alt="Manpower team at work" />
              </div>
            </div>

            {/* Right Column - Experience */}
            {/* <div className="col-lg-3" data-aos="fade-left">
              <div className="manpower-card text-center text-lg-start p-4">
                <div className="mb-3 text-center text-lg-start">
                  <i className="bi bi-person-workspace" style={{ fontSize: '3rem', color: '#cbd5e1' }}></i>
                </div>
                <h3 className="fw-bold mb-3" style={{ fontSize: '1.6rem', color: '#ffffff' }}>Experience</h3>
                <p style={{ fontSize: '1rem', lineHeight: '1.7', color: '#e9eefc' }}>
                  With their expertise and dedication, we aim to optimize drilling performance,
                  reduce costs, and ensure the success of your drilling projects.
                </p>
                <button
                  type="button"
                  className="fw-bold text-decoration-none d-inline-block mt-2 btn btn-outline-warning"
                  style={{ fontSize: '0.95rem' }}
                  onClick={() => navigate('/services/manpower')}
                >
                  LEARN MORE
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
      */} 

      {/* Services Section */}
      
      <div
        className="position-relative"
        style={{
          backgroundImage: `url('/assets/parallex3.jpg')`,
          backgroundAttachment: 'fixed',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          minHeight: '80vh',
          width: '100%',
        }}
      >
        <div
          className="position-absolute top-0 start-0 w-100 h-100"
        ></div>
      </div>

      <section
        className="position-relative w-100"
        style={{
          minHeight: '80vh',
          width: '100%',
          background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 50%, #f1f5f9 100%)'
        }}
      >
        {/* Background Pattern */}
        <div
          className="position-absolute top-0 start-0 w-100 h-100"
          style={{
            backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23cbd5e1' fill-opacity='0.1'%3E%3Ccircle cx='30' cy='30' r='2'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
            opacity: 0.6,
            zIndex: 1
          }}
        ></div>

        <div className="container position-relative py-5" style={{ zIndex: 2 }}>
          <div className="row align-items-center g-5">
            <div className="col-lg-6 mb-4 mb-lg-0" data-aos="slide-right">
              <div className="position-relative">
                <div
                  className="position-relative rounded-4 overflow-hidden"
                  style={{
                    boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
                    border: '3px solid rgba(71, 85, 105, 0.2)'
                  }}
                >
                  <img
                    src="/assets/workers.png"
                    alt="Agency Team"
                    className="img-fluid w-100"
                    style={{ height: '400px', objectFit: 'cover' }}
                  />
                  <div
                    className="position-absolute top-0 start-0 w-100 h-100"
                    style={{
                      background: 'linear-gradient(45deg, rgba(71, 85, 105, 0.2) 0%, rgba(100, 116, 139, 0.2) 100%)'
                    }}
                  ></div>
                </div>

                {/* Floating Badge */}
                <div
                  className="position-absolute top-3 end-3 bg-white rounded-4 px-3 py-2 shadow-lg"
                  style={{
                    border: '1px solid rgba(71, 85, 105, 0.2)',
                    backdropFilter: 'blur(10px)'
                  }}
                >
                  <span style={{ color: '#475569', fontSize: '0.8rem', fontWeight: '600' }}>
                    PARTNERSHIP
                  </span>
                </div>
              </div>
            </div>

            <div className="col-lg-6" data-aos="flip-left">
              <div className="ps-lg-4">
                {/* Badge */}
                <div className="mb-3">
                  <span
                    className="badge px-3 py-2"
                    style={{
                      backgroundColor: 'rgba(71, 85, 105, 0.1)',
                      color: '#475569',
                      fontSize: '0.85rem',
                      fontWeight: '500',
                      borderRadius: '20px',
                      border: '1px solid rgba(71, 85, 105, 0.2)'
                    }}
                  >
                    STRATEGIC ALLIANCES
                  </span>
                </div>

                <h3
                  className="fw-bold mb-3"
                  style={{
                    color: '#1e293b',
                    fontFamily: 'Poppins, sans-serif',
                    fontSize: '2.5rem',
                    letterSpacing: '-0.2px',
                    lineHeight: '1.2'
                  }}
                >
                  Our Agencies
                </h3>

                <h6
                  className="mb-4"
                  style={{
                    color: '#475569',
                    fontFamily: 'Poppins, sans-serif',
                    fontWeight: 500,
                    fontSize: '1.1rem',
                  }}
                >
                  Petrochoice Petroleum Service
                </h6>

                <p
                  style={{
                    fontSize: '1.15rem',
                    lineHeight: '2.2',
                    fontFamily: 'Poppins, sans-serif',
                    color: '#64748b',
                    fontWeight: 300,
                    textAlign: 'justify',
                    marginBottom: '2rem'
                  }}
                >
                  We have established partnerships with reputable agencies and technology providers,
                  enabling us to offer a comprehensive suite of solutions. These agencies complement
                  our services by providing specialized tools, software, and equipment to address specific
                  industry challenges. We continuously evaluate and collaborate with agencies to ensure
                  our clients have access to the latest innovations.
                </p>

                {/* CTA Button */}
                <button
                  type="button"
                  className="btn btn-lg fw-bold px-4 py-3"
                  style={{
                    borderRadius: '12px',
                    fontSize: '1rem',
                    background: 'linear-gradient(90deg, #0c61c0, #084b9a)',
                    border: '1px solid #0c61c0',
                    color: '#f8fafc',
                    boxShadow: '0 8px 20px rgba(12, 97, 192, 0.35)',
                    transition: 'all 0.3s ease'
                  }}
                  onClick={() => navigate('/agencies')}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'translateY(-2px)';
                    e.currentTarget.style.boxShadow = '0 12px 25px rgba(12, 97, 192, 0.45)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.boxShadow = '0 8px 20px rgba(12, 97, 192, 0.35)';
                  }}
                >
                  Explore Partnerships <i className="fas fa-arrow-right ms-2"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Home;
